/**
 * `/admin/studies/$id` — a study opened from the Admin board, in the Admin shell. Same page and
 * lifecycle components as the workspace route (`features/studies/StudyPage.tsx`); staff work as
 * themselves (the backend authorizes and audits the verified platform admin per study), so there is
 * no acting state, banner or Exit. Studies/back returns to the admin list with its filters.
 */

import { createFileRoute } from "@tanstack/react-router";
import { StudyPage } from "@/features/studies/StudyPage";
import { validateStudySearch } from "@/features/studies/studySearch";
import { ensureStaffStudy } from "@/features/studies/stage";
import { StudySurfaceProvider } from "@/features/studies/studySurface";

function AdminStudy() {
  const { id } = Route.useParams();
  const { tab, step } = Route.useSearch();
  return (
    <StudySurfaceProvider value="admin">
      <StudyPage id={id} tab={tab} step={step} />
    </StudySurfaceProvider>
  );
}

export const Route = createFileRoute("/_auth/admin/studies/$id/")({
  validateSearch: validateStudySearch,
  beforeLoad: ({ context, params, preload }) =>
    ensureStaffStudy(context.queryClient, params.id, preload),
  component: AdminStudy,
});
